// Source: https://usehooks-ts.com/react-hook/use-hover.
import { useRef, useState } from 'react';
import useEventListener from './use-event-listener.js';
import useIsMounted from './use-is-mounted.js';
/**
 * Custom hook that tracks whether a DOM element is being hovered over.
 */
function useHover(elementRef, { delay = 0 } = {}) {
    const [value, setValue] = useState(false);
    const timerIdRef = useRef(null);
    const isMounted = useIsMounted();
    const handleMouseEnter = () => {
        timerIdRef.current = setTimeout(() => {
            if (isMounted()) {
                setValue(true);
            }
        }, delay);
    };
    const handleMouseLeave = () => {
        const timerId = timerIdRef.current;
        if (timerId) {
            clearTimeout(timerId);
            timerIdRef.current = null;
        }
        setValue(false);
    };
    useEventListener('mouseenter', handleMouseEnter, elementRef);
    useEventListener('mouseleave', handleMouseLeave, elementRef);
    return value;
}
export default useHover;
